var LEARN_MORE_LINK_URL = 'https://www.microsoft.com/en-gb/industry?rtc=1';
var industryCloudsItems = [
    {
        title: 'Microsoft Cloud for Financial Services',
        icon: 'Bank',
        description: 'Providing capabilities to manage data and to empower finance employees.',
        navigateOptions: {
            type: 'CloudsIndustry',
            query: {
                industry: 'financial-services'
            }
        }
    },
    {
        title: 'Microsoft Cloud for Healthcare',
        icon: 'Health',
        description: 'Trusted and integrated capabilities to deliver better healthcare experiences, better insights and better care.',
        navigateOptions: {
            type: 'CloudsIndustry',
            query: {
                industry: 'healthcare'
            }
        }
    },
    {
        title: 'Microsoft Cloud for Retail',
        icon: 'BusinessHoursSign',
        description: 'Accelerate business growth by providing trusted solutions that easily integrate, connect your customers, people and data.',
        navigateOptions: {
            type: 'CloudsIndustry',
            query: {
                industry: 'retail-and-consumer-goods'
            }
        }
    },
    {
        title: 'Microsoft for Nonprofits',
        icon: 'Commitments',
        description: 'Explore cloud capabilities to provide nonprofits with a holistic platform to help accelerate mission outcomes.',
        navigateOptions: {
            type: 'CloudsIndustry',
            query: {
                industry: 'nonprofit'
            }
        }
    },
    {
        title: 'Microsoft Cloud for Sustainability',
        icon: 'Cotton',
        description: 'Helps organizations accelerate sustainability progress and business growth with a growing set of ESG capabilities.',
        navigateOptions: {
            type: 'CloudsIndustry',
            query: {
                industry: 'sustainability'
            }
        }
    }
];
var unifiedStoreIndustryCloudItems = [
    {
        title: 'Microsoft Cloud for Financial Services',
        icon: 'Bank',
        description: 'Providing capabilities to manage data and to empower finance employees.',
        navigateOptions: {
            type: 'CloudsIndustry',
            query: {
                industry: 'financial-services'
            }
        }
    },
    {
        title: 'Microsoft Cloud for Healthcare',
        icon: 'Health',
        description: 'Trusted and integrated capabilities to deliver better healthcare experiences, better insights and better care.',
        navigateOptions: {
            type: 'CloudsIndustry',
            query: {
                industry: 'healthcare'
            }
        }
    },
    {
        title: 'Microsoft Cloud for Retail',
        icon: 'BusinessHoursSign',
        description: 'Accelerate business growth by providing trusted solutions that easily integrate, connect your customers, people and data.',
        navigateOptions: {
            type: 'CloudsIndustry',
            query: {
                industry: 'retail-and-consumer-goods'
            }
        }
    },
    {
        title: 'Microsoft for Nonprofits',
        icon: 'Commitments',
        description: 'Explore cloud capabilities to provide nonprofits with a holistic platform to help accelerate mission outcomes.',
        navigateOptions: {
            type: 'CloudsIndustry',
            query: {
                industry: 'nonprofit'
            }
        }
    },
    {
        title: 'Microsoft Cloud for Sustainability',
        icon: 'Cotton',
        description: 'Helps organizations accelerate sustainability progress and business growth with a growing set of ESG capabilities.',
        navigateOptions: {
            type: 'CloudsIndustry',
            query: {
                industry: 'sustainability'
            }
        }
    }
];

export { LEARN_MORE_LINK_URL, industryCloudsItems, unifiedStoreIndustryCloudItems };
